import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";

const DeleteSurveyQuestionnaireOptionApiService = async (
  request: number
  // eslint-disable-next-line
): Promise<any> => {
  const url = `/formquestions/${request}/options/`;
  const { data } = await axios.delete(url);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useDeleteSurveyQuestionnaireOptionApiService = () =>
  // eslint-disable-next-line
  useMutation<any, AxiosError, any>(DeleteSurveyQuestionnaireOptionApiService, {
    mutationKey: ["DeleteSurveyQuestionOptionApiService"],
  });
export default useDeleteSurveyQuestionnaireOptionApiService;
